import { render, staticRenderFns } from "./DeliveryProofSenders.vue?vue&type=template&id=789e8860&scoped=true"
import script from "./DeliveryProofSenders.vue?vue&type=script&lang=js"
export * from "./DeliveryProofSenders.vue?vue&type=script&lang=js"
import style0 from "./DeliveryProofSenders.vue?vue&type=style&index=0&id=789e8860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e8860",
  null
  
)

export default component.exports